// import { useEffect } from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import ProtectedRoute, { HomeRedirect } from "./components/ProtectedRoute";
// import { fetchCurrentUser } from "./slice/authSlice";
// import Login from "./pages/Login";
// import Register from "./pages/Register";
// import Dashboard from "./pages/Dashboard";
// import CandidateForm from "./pages/CandidateForm";
// import CandidateDetail from "./pages/CandidateDetail";
// import NewOptimization from "./pages/NewOptimization";
// import OptimizationList from "./pages/OptimizationList";
// import OptimizationDetail from "./pages/OptimizationDetail";
// import ClientList from "./pages/ClientList";
// import AdminPanel from "./pages/AdminPanel";
// import ScreeningInterview from "./pages/ScreeningInterview";
// import ScreeningReport from "./pages/ScreeningReport";
// import ScreeningList from "./pages/ScreeningList";
// import AdminScreeningDashboard from "./pages/AdminScreeningDashboard";
// import "./index.css";
// import ForgotPassword from "./pages/ForgotPassword";
// import ResetPassword from "./pages/ResetPassword";

// function App() {
//   const dispatch = useDispatch();

//   // On every app load (including reopening the browser), ask the backend
//   // "who am I?" using the httpOnly cookie. Valid cookie -> user is restored
//   // and stays signed in; missing/expired cookie -> treated as logged out.
//   useEffect(() => {
//     dispatch(fetchCurrentUser());
//   }, [dispatch]);

//   return (
//     <BrowserRouter>
//       <Routes>
//         {/* Root URL: signed-in users go to their home page, others to login */}
//         <Route path="/" element={<HomeRedirect />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/register" element={<Register />} />
//         <Route path="/register" element={<Register />} />

//         {/* Forgot password (PUBLIC — user is logged out) */}
//         <Route path="/forgot-password" element={<ForgotPassword />} />
//         <Route path="/reset-password/:token" element={<ResetPassword />} />
//         <Route
//           path="/dashboard"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
//               <Dashboard />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/dashboard/candidates/:id"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
//               <CandidateDetail />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/dashboard/candidates/:id/edit"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER"]}>
//               <CandidateForm />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/dashboard/clients"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
//               <ClientList />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/dashboard/optimizations"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
//               <OptimizationList />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/dashboard/optimizations/:id"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
//               <OptimizationDetail />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/dashboard/optimizations/new"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER"]}>
//               <NewOptimization />
//             </ProtectedRoute>
//           }
//         />

//         {/* AI screening tracker — TL/RECRUITER see their own (admins are redirected to the dashboard) */}
//         <Route
//           path="/dashboard/screenings"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
//               <ScreeningList />
//             </ProtectedRoute>
//           }
//         />

//         {/* AI screening report (recruiter, login required) */}
//         <Route
//           path="/dashboard/screenings/:id"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
//               <ScreeningReport />
//             </ProtectedRoute>
//           }
//         />

//         {/* AI screening interview (candidate, PUBLIC — no login, no top nav) */}
//         <Route path="/screening/:token" element={<ScreeningInterview />} />

//         <Route
//           path="/admin"
//           element={
//             <ProtectedRoute allowedRoles={["ADMIN"]}>
//               <AdminPanel />
//             </ProtectedRoute>
//           }
//         />

//         {/* Admin: AI screening dashboard for the whole team */}
//         <Route
//           path="/admin/screenings"
//           element={
//             <ProtectedRoute allowedRoles={["ADMIN"]}>
//               <AdminScreeningDashboard />
//             </ProtectedRoute>
//           }
//         />

//         <Route path="*" element={<HomeRedirect />} />
//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;

// import { useEffect } from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import ProtectedRoute, { HomeRedirect } from "./components/ProtectedRoute";
// import { fetchCurrentUser } from "./slice/authSlice";
// import Login from "./pages/Login";
// import Register from "./pages/Register";
// import Dashboard from "./pages/Dashboard";
// import CandidateForm from "./pages/CandidateForm";
// import CandidateDetail from "./pages/CandidateDetail";
// import NewOptimization from "./pages/NewOptimization";
// import OptimizationList from "./pages/OptimizationList";
// import OptimizationDetail from "./pages/OptimizationDetail";
// import ClientList from "./pages/ClientList";
// import AdminPanel from "./pages/AdminPanel";
// import ScreeningInterview from "./pages/ScreeningInterview";
// import ScreeningReport from "./pages/ScreeningReport";
// import ScreeningList from "./pages/ScreeningList";
// import AdminScreeningDashboard from "./pages/AdminScreeningDashboard";
// import "./index.css";
// import ForgotPassword from "./pages/ForgotPassword";
// import ResetPassword from "./pages/ResetPassword";
// import VerifyEmail from "./pages/VerifyEmail";

// function App() {
//   const dispatch = useDispatch();

//   // On every app load (including reopening the browser), ask the backend
//   // "who am I?" using the httpOnly cookie. Valid cookie -> user is restored
//   // and stays signed in; missing/expired cookie -> treated as logged out.
//   useEffect(() => {
//     dispatch(fetchCurrentUser());
//   }, [dispatch]);

//   return (
//     <BrowserRouter>
//       <Routes>
//         {/* Root URL: signed-in users go to their home page, others to login */}
//         <Route path="/" element={<HomeRedirect />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/register" element={<Register />} />
//         <Route path="/register" element={<Register />} />

//         {/* Forgot password (PUBLIC — user is logged out) */}
//         <Route path="/forgot-password" element={<ForgotPassword />} />
//         <Route path="/reset-password/:token" element={<ResetPassword />} />

//         {/* Email verification link from the sign-up email (PUBLIC) */}
//         <Route path="/verify-email/:token" element={<VerifyEmail />} />
//         <Route
//           path="/dashboard"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
//               <Dashboard />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/dashboard/candidates/:id"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
//               <CandidateDetail />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/dashboard/candidates/:id/edit"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER"]}>
//               <CandidateForm />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/dashboard/clients"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
//               <ClientList />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/dashboard/optimizations"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
//               <OptimizationList />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/dashboard/optimizations/:id"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
//               <OptimizationDetail />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/dashboard/optimizations/new"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER"]}>
//               <NewOptimization />
//             </ProtectedRoute>
//           }
//         />

//         {/* AI screening tracker — TL/RECRUITER see their own (admins are redirected to the dashboard) */}
//         <Route
//           path="/dashboard/screenings"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
//               <ScreeningList />
//             </ProtectedRoute>
//           }
//         />

//         {/* AI screening report (recruiter, login required) */}
//         <Route
//           path="/dashboard/screenings/:id"
//           element={
//             <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
//               <ScreeningReport />
//             </ProtectedRoute>
//           }
//         />

//         {/* AI screening interview (candidate, PUBLIC — no login, no top nav) */}
//         <Route path="/screening/:token" element={<ScreeningInterview />} />

//         <Route
//           path="/admin"
//           element={
//             <ProtectedRoute allowedRoles={["ADMIN"]}>
//               <AdminPanel />
//             </ProtectedRoute>
//           }
//         />

//         {/* Admin: AI screening dashboard for the whole team */}
//         <Route
//           path="/admin/screenings"
//           element={
//             <ProtectedRoute allowedRoles={["ADMIN"]}>
//               <AdminScreeningDashboard />
//             </ProtectedRoute>
//           }
//         />

//         <Route path="*" element={<HomeRedirect />} />
//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;

import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import ProtectedRoute, { HomeRedirect } from "./components/ProtectedRoute";
import { fetchCurrentUser } from "./slice/authSlice";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import CandidateForm from "./pages/CandidateForm";
import CandidateDetail from "./pages/CandidateDetail";
import NewOptimization from "./pages/NewOptimization";
import OptimizationList from "./pages/OptimizationList";
import OptimizationDetail from "./pages/OptimizationDetail";
import ClientList from "./pages/ClientList";
import AdminPanel from "./pages/AdminPanel";
import ScreeningInterview from "./pages/ScreeningInterview";
import ScreeningReport from "./pages/ScreeningReport";
import ScreeningList from "./pages/ScreeningList";
import AdminScreeningDashboard from "./pages/AdminScreeningDashboard";
import "./index.css";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import useSessionSync from "./hooks/useSessionSync";

function App() {
  const dispatch = useDispatch();

  // All tabs share one login cookie: when another tab logs in as someone
  // else (or logs out), reload this tab so it never shows a mix of users.
  useSessionSync();

  // On every app load (including reopening the browser), ask the backend
  // "who am I?" using the httpOnly cookie. Valid cookie -> user is restored
  // and stays signed in; missing/expired cookie -> treated as logged out.
  useEffect(() => {
    dispatch(fetchCurrentUser());
  }, [dispatch]);

  return (
    <BrowserRouter>
      <Routes>
        {/* Root URL: signed-in users go to their home page, others to login */}
        <Route path="/" element={<HomeRedirect />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/register" element={<Register />} />

        {/* Forgot password (PUBLIC — user is logged out) */}
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        {/* Email verification link from the sign-up email (PUBLIC) */}
        <Route path="/verify-email/:token" element={<VerifyEmail />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/candidates/:id"
          element={
            <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
              <CandidateDetail />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/candidates/:id/edit"
          element={
            <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER"]}>
              <CandidateForm />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/clients"
          element={
            <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
              <ClientList />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/optimizations"
          element={
            <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
              <OptimizationList />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/optimizations/:id"
          element={
            <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
              <OptimizationDetail />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/optimizations/new"
          element={
            <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER"]}>
              <NewOptimization />
            </ProtectedRoute>
          }
        />

        {/* AI screening tracker — TL/RECRUITER see their own (admins are redirected to the dashboard) */}
        <Route
          path="/dashboard/screenings"
          element={
            <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
              <ScreeningList />
            </ProtectedRoute>
          }
        />

        {/* AI screening report (recruiter, login required) */}
        <Route
          path="/dashboard/screenings/:id"
          element={
            <ProtectedRoute allowedRoles={["TEAM_LEAD", "RECRUITER", "ADMIN"]}>
              <ScreeningReport />
            </ProtectedRoute>
          }
        />

        {/* AI screening interview (candidate, PUBLIC — no login, no top nav) */}
        <Route path="/screening/:token" element={<ScreeningInterview />} />

        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={["ADMIN"]}>
              <AdminPanel />
            </ProtectedRoute>
          }
        />

        {/* Admin: AI screening dashboard for the whole team */}
        <Route
          path="/admin/screenings"
          element={
            <ProtectedRoute allowedRoles={["ADMIN"]}>
              <AdminScreeningDashboard />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<HomeRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;